export default __webpack_public_path__ + "static/media/mixg day2_201103_2.e3f3ecfc.jpg";